// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const eternatus: PokeData = {
  "id": 890,
  "name": "eternatus",
  "height": 200,
  "weight": 9500,
  "base_experience": 345,
  "types": [
    PokeType.POISON,
    PokeType.DRAGON
  ],
  "api_moves": [
    "flamethrower",
    "hyper-beam",
    "toxic",
    "agility",
    "recover",
    "confuse-ray",
    "outrage",
    "cosmic-power",
    "poison-tail",
    "dragon-dance",
    "dragon-pulse",
    "cross-poison",
    "venoshock",
    "dragon-tail",
    "dynamax-cannon",
    "eternabeam"
  ],
  "moves": [
    "flamethrower",
    "confuse-ray",
    "outrage",
    "dragon-dance",
    "dragon-pulse",
    "inner-spirit",
    "poison-gas",
    "dragon-breath",
    "draco-meteor",
    "dragon-rush",
    "acid",
    "poison-jab",
    "toxic-overload"
  ],
  "evolution_chain": {
    "id": 469,
    "item": null,
    "species": [
      {
        "name": "eternatus",
        "order": 890,
        "types": [
          PokeType.POISON,
          PokeType.DRAGON
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      }
    ]
  },
  "stats": {
    "resistance": 120,
    "speed": 132,
    "ability_power": 148
  },
  "stat_changes": [],
  "catch_rate": 255,
  "is_legendary": true,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
